/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { LISTING_STATUS } from './constants/listingStatus';
import {
  findListingEntity,
  getListingProductIdFromState,
  listListingVariantIdsForChannel,
} from './helpers/entityReadHelpers';
import { removeListing, removeListingVariant } from './helpers/entityAdapter';
import { setActiveTabByProductChannel, setSelectedChannelByProduct } from './helpers/uiAdapter';

export const deleteProductDraft = createAsyncThunk(
  'products/deleteProductDraft',
  async ({ masterProductId, channelId }, { getState, extra: { sdk } }) => {
    const listingProductId = getListingProductIdFromState(getState().products, masterProductId, channelId);

    if (!listingProductId) {
      throw new Error(`Staging product not found for channel ${channelId}`);
    }

    const existingListing = findListingEntity(getState().products, { masterProductId, channelId });
    await sdk.products.deleteListing(listingProductId);

    return {
      masterProductId,
      channelId,
      wasPublished: Boolean(existingListing?.live),
    };
  },
);

export const reducer = (builder) => {
  builder
    .addCase(deleteProductDraft.pending, (state) => {
      state.isBusy = true;
      state.error = null;
    })
    .addCase(deleteProductDraft.fulfilled, (state, { payload }) => {
      const { masterProductId, channelId, wasPublished } = payload;
      state.isBusy = false;

      const existingListing = findListingEntity(state, { masterProductId, channelId });
      const listingProductId = existingListing?._id;
      const listingVariantIds = listListingVariantIdsForChannel(state, masterProductId, channelId);

      listingVariantIds.forEach((listingVariantId) => {
        removeListingVariant(state, listingVariantId);
      });

      if (wasPublished) {
        if (listingProductId) {
          removeListing(state, listingProductId);
        }
        setActiveTabByProductChannel(state, masterProductId, channelId, LISTING_STATUS.PUBLISHED);
        setSelectedChannelByProduct(state, masterProductId, channelId);
        return;
      }

      if (listingProductId) {
        removeListing(state, listingProductId);
      }
      setSelectedChannelByProduct(state, masterProductId, 'master');
    })
    .addCase(deleteProductDraft.rejected, (state, { error }) => {
      state.isBusy = false;
      state.error = error?.message || 'Cannot delete listing';
    });
};
